class PageMain {
    constructor() {
        this.factoidsContainer = document.querySelector('.js-factoids');
        this.factoids = document.querySelectorAll('.js-map-factoid');
        this.mapLayers = document.querySelectorAll('.js-map-layer');
        this.map = document.querySelector('.js-map');

        this.bindClick();
        this.bindFactoids();
        this.bindFactoidsMobile();
    }

    /**
     * Скроллим кликом по стрелке
     */
    bindClick() {
        document.querySelectorAll('.js-mp-next').forEach(btn => {
            btn.addEventListener('click', () => {
                const top = btn.closest('.js-mp-screen').nextElementSibling.offsetTop;

                $('html, body').animate({
                    scrollTop: top
                }, 500);
            });
        });
    }


    bindFactoids() {
        if (App.mobile) return;

        this.factoids.forEach(factoid => {
            factoid.addEventListener('mouseenter', () => {
                this.changeMapLayer(+factoid.getAttribute('data-id'));
            });

            factoid.addEventListener('mouseleave', () => {
                this.changeMapLayer();
            });
        });
    }


    bindFactoidsMobile() {
        if (!App.mobile) return;

        this.factoids.forEach(factoid => {
            factoid.addEventListener('click', () => {
                this.changeMapLayer(+factoid.getAttribute('data-id'));
            });
        });

        document.addEventListener('click', e => {
            if (!this.factoidsContainer.contains(e.target)) {
                this.changeMapLayer();
            }
        });
    }


    /**
     * Меняем слои карты
     */
    changeMapLayer(id=1) {
        /**
         * Если ничего не выбрано, выделяем первый слой
         */
        this.map.classList.remove('_is-layer-1', '_is-layer-2', '_is-layer-3');
        this.map.classList.add('_is-layer-' + id);

        this.factoids.forEach(f => {
            if (+f.getAttribute('data-id') === id) {
                f.classList.add('_is-active');
            } else {
                f.classList.remove('_is-active');
            }
        });
    }
}

if (document.querySelector('html.page-main')) {
    new PageMain();
}



// WEBPACK FOOTER //
// ./_src/js/PageMain.js